// extracted by mini-css-extract-plugin
export default {"Article":"Table_Article__buvwI","Table":"Table_Table__3tTIR","DatePicker":"Table_DatePicker__CdfYa","DatePickerW":"Table_DatePickerW__Jef26"};